const productEvents = {
  FETCH_PRODUCT_DATA_PROGRESS: 'product/fetch_data_progress',
  FETCH_PRODUCT_DATA_SUCCESS: 'product/fetch_data_success',
  FETCH_PRODUCT_DATA_NOT_FOUND: 'product/fetch_data_not_found',
  FETCH_PRODUCT_DATA_FAILED: 'product/fetch_data_failed',
  UPDATE_SELECTED_PRODUCT: 'product/update_product',
};
export default productEvents;
